import { useEffect, useRef } from 'react'
import {WhyGoSolar} from './WhyGoSolar.js'
import { Link } from 'react-router-dom'
import { ASSETS_URL } from '../utils/constants'

const prodHuaweiInverter = ASSETS_URL + 'huawei-inverter-total-solar-2.webp'
const prodTrinaSolar = ASSETS_URL + 'trina-solar-total-solar-2.png'
const prodLappKabel = ASSETS_URL + 'lapp-kabel-total-solar-1.jpeg'

function Careers() {
    const containerRef = useRef(null)

    useEffect(() => {
      if(containerRef.current) {
        containerRef.current.parentNode.parentNode.scrollIntoView({ behavior: "smooth", block: "start", inline: "start" })
      }
    }, [containerRef])

    return <>
        <div ref={containerRef} className="font-[Montserrat] min-h-[75vh] w-[80%] text-[#f7f7f7] text-left my-10 flex items-center flex-col">
          <div className='text-[#4CB117] text-center text-3xl sm:text-5xl font-extrabold pb-3 pt-3'>Careers</div>
          
          <div className='text-[#f7f7f7] text-center text-m mt-2 pb-20'>Come and join us!</div>
          
          
        </div>
    </>
}


export default Careers;